import '../styles/globals.css';
import '../instrumentation-client';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { installCsrfFetchInterceptor } from '../lib/api-fetch';

export default function App({ Component, pageProps }: AppProps) {
  // Install CSRF fetch interceptor once on client-side mount
  useEffect(() => {
    installCsrfFetchInterceptor();
  }, []);

  useEffect(() => {
    const handler = (event: ErrorEvent) => {
      fetch('/api/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event: 'client_error',
          error: event.message,
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
        }),
      }).catch(() => {}); // fire-and-forget
    };

    window.addEventListener('error', handler);
    return () => window.removeEventListener('error', handler);
  }, []);

  return (
    <PostHogProvider client={posthog}>
      <Head>
        <title>Decent Kit - Authentication</title>
        <meta name='description' content='Centralized authentication for Decent Kit applications' />
      </Head>
      <Component {...pageProps} />
    </PostHogProvider>
  );
}
